/**
 * Builds the CSS custom properties consumed by the `.lazylog-search` styles
 * from a ThemeStyle entry (ThemeStyle[theme]). Shared by the raw-log viewers
 * so the inline `--ll-*` style object isn't repeated/inlined in JSX.
 *
 * @param {Object} themeEntry - e.g. ThemeStyle[theme]
 * @returns {Object} style object with `--ll-*` CSS variables
 */
export const getLazyLogThemeVars = (themeEntry = {}) => ({
  '--ll-bar-bg': themeEntry.backgroundColor,
  '--ll-input-bg': themeEntry.searchInputBg,
  '--ll-text': themeEntry.searchText,
  '--ll-border': themeEntry.searchBorder,
  '--ll-accent': themeEntry.searchAccent,
  '--ll-muted': themeEntry.searchMuted,
});
